import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface SocialProofAvatar {
  id: string;
  username: string;
  photo_url: string | null;
}

interface SocialProofStats {
  total_sponsors: number;
  paying_users_count: number;
  top_avatars: SocialProofAvatar[];
}

export const useSocialProofStats = () => {
  return useQuery({
    queryKey: ['social-proof-stats'],
    queryFn: async (): Promise<SocialProofStats> => {
      const { data, error } = await supabase.rpc('get_social_proof_stats');
      
      if (error) {
        console.error('[SocialProof] Erro ao buscar stats:', error);
        throw error;
      }
      
      // Parse response com type assertion segura
      const parsed = data as unknown as SocialProofStats;
      
      return {
        total_sponsors: parsed?.total_sponsors ?? 0,
        paying_users_count: parsed?.paying_users_count ?? 0,
        top_avatars: parsed?.top_avatars ?? []
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutos de cache
    gcTime: 30 * 60 * 1000,   // 30 minutos
    refetchOnWindowFocus: false,
  });
};
